/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineIdPreviewChannels200,
  GetApiV1ClassroomdisciplineIdPreviewChannels401,
  GetApiV1ClassroomdisciplineIdPreviewChannels404,
  GetApiV1ClassroomdisciplineIdPreviewChannelsPathParams,
  GetApiV1ClassroomdisciplineIdPreviewChannelsQueryResponse,
} from "../../types/classPlanningChannelsController/GetApiV1ClassroomdisciplineIdPreviewChannels.ts";
import { previewChannelsViewModelSchema } from "../previewChannelsViewModelSchema.ts";

export const getApiV1ClassroomdisciplineIdPreviewChannelsPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1ClassroomdisciplineIdPreviewChannelsPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineIdPreviewChannels200Schema = z.lazy(
  () => previewChannelsViewModelSchema,
) as unknown as ToZod<GetApiV1ClassroomdisciplineIdPreviewChannels200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineIdPreviewChannels401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdPreviewChannels401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ClassroomdisciplineIdPreviewChannels404Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdPreviewChannels404>;

export const getApiV1ClassroomdisciplineIdPreviewChannelsQueryResponseSchema =
  z.lazy(
    () => getApiV1ClassroomdisciplineIdPreviewChannels200Schema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineIdPreviewChannelsQueryResponse>;
